import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import ContainerView from '../views/ContainerView.vue'
import IntroJoin from '../views/IntroJoin.vue'
import IntroModel from '../views/IntroModel.vue'
// import International from '../views/International.vue'
// import GoodsDetail from '../views/GoodsDetail.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/international',
    redirect: '/404'
  },
  {
    path: '/goods-detail/:price/:imgUrl',
    redirect: '/404'
  },
  {
    path: '/404',
    name: 'notFound',
    component: NotFound
  },
  // 介绍页-加入绿色循环
  {
    path: '/intro-join',
    name: 'introJoin',
    component: IntroJoin
  },
  // 介绍页-企业榜样
  {
    path: '/intro-model',
    name: 'introModel',
    component: IntroModel
  },
  // 首页
  {
    path: '*',
    name: 'container',
    component: ContainerView
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: '/platform/official_global/',
  routes
})

export default router
